import styled from 'styled-components'
import { theme, colors, StyledExternalLink } from '../../../theme/Global/index'

export const CustomLink = styled(StyledExternalLink)`  
  color: ${theme.colors.whiteText};
  margin: 0;
  min-width: 88px;
  padding: 8px 16px;

  :hover {
    background-color: ${colors.govDocsBlue};
  }
`
